import styled from "styled-components"

export const LoaderContainer = styled.div`
          text-align: center;
  `

